import { LOGOUT, ILogout } from "./types";

export const logout = (): ILogout => ({ type: LOGOUT });
